import App from '../../../models/app';

export const sortFavoriteClockfaces = (clocks: App[] = [], activeClock: App): App[] => {
  return [...clocks]
    .sort(({ id }) => (id === activeClock.id ? -1 : 1));
}